import { useSelector } from 'react-redux';
import State from 'store/State';
import { selectWidgetSharedState } from '../selectors';
import { WidgetSharedStateSection } from '../WidgetsSharedState';

const selectAlgorithmParametersSharedState = (state: State) =>
    selectWidgetSharedState(state)[
        WidgetSharedStateSection.ALGORITHM_PARAMETERS
    ];

const selectAlgorithmParametersRevisionIndex = (state: State) => {
    const sharedState = selectAlgorithmParametersSharedState(state);
    return sharedState !== undefined && sharedState.revisionIndex !== null
        ? sharedState.revisionIndex
        : undefined;
};

export const useSelectAlgorithmParametersRevisionIndex = () =>
    useSelector((state: State) =>
        selectAlgorithmParametersRevisionIndex(state)
    );
